import {
  GET_SELECTED_ACTION_TILES,
  GET_SELECTED_ACTION_TILES_SUCCESS,
  GET_SELECTED_ACTION_TILES_FAILURE,
  RESET_SELECTED_ACTION_TILES,
} from "../Action/actionTypes";

interface GetSelectedActionTilesState {
  SelectedActionTilesData: {};
}

const initialState: GetSelectedActionTilesState = {
  SelectedActionTilesData: {},
};

const SelectedActionTilesReducer = (
  state: GetSelectedActionTilesState = initialState,
  action: any
): GetSelectedActionTilesState => {
  switch (action.type) {
    case GET_SELECTED_ACTION_TILES:
    case GET_SELECTED_ACTION_TILES_FAILURE:
      return {
        ...state,
      };

    case GET_SELECTED_ACTION_TILES_SUCCESS:
      return {
        ...state,
        SelectedActionTilesData: action.payload,
      };

    case RESET_SELECTED_ACTION_TILES:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default SelectedActionTilesReducer;
